import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { VideoTextSection as Original } from 'components/organisms'
import {
  VideoTextSectionSettings,
  VideoTextSectionFloatingSettings,
} from './VideoTextSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import {
  videoDefaultProps,
  videoItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'

export const defaultProps = {
  ...videoDefaultProps(['controls']),
  theme: 'light',
}

export const videoTextSectionItemParams = (enabled, id, blockProps, children) => ({
  ...videoItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const VideoTextSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-video-text-section ${props.className}`}
      >
        <Original
          item={videoTextSectionItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

VideoTextSection.craft = withCraft({
  name: 'VideoTextSection',
  defaultProps: defaultProps,
  settings: VideoTextSectionSettings,
  floatingSettings: VideoTextSectionFloatingSettings,
})
